import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    checkoutElements?: {
      init: (type: string) => {
        mount: (selector: string) => void;
      };
    };
  }
}
export function HotmartFunnel() {
  useEffect(() => {
    const SCRIPT_SRC = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    const MOUNT_ID = 'hotmart-sales-funnel';
    const mountWidget = () => {
      try {
        if (window.checkoutElements && document.getElementById(MOUNT_ID)) {
          window.checkoutElements.init('salesFunnel').mount(`#${MOUNT_ID}`);
        }
      } catch (e) {
        // silently ignore — widget script handles its own errors
      }
    };
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      mountWidget();
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = mountWidget;
    document.body.appendChild(script);
  }, []);
  return <div className="w-full" data-id="element-6">
      <div id="hotmart-sales-funnel" data-id="element-7" />
    </div>;
}